import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { STEPS } from "../../content/site";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./motion";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 60%"] });
  const len = useTransform(scrollYProgress, [0, 1], [0, 1]);
  return (
    <section id="ablauf" data-testid="process-section" className="relative bg-[#0D2F18] py-24 md:py-36">
      <div className="grain absolute inset-0" />
      <div ref={ref} className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead light eyebrow="So läuft es ab" lines={["In drei Schritten", "zum gepflegten Garten."]} />
        <div className="relative mt-20">
          <svg className="absolute left-0 right-0 top-8 hidden h-6 w-full md:block" viewBox="0 0 1000 24" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0 12 C 160 -6, 330 30, 500 12 S 840 -6, 1000 12" stroke="rgba(220,239,190,.18)" strokeWidth="2" fill="none" />
            <motion.path d="M0 12 C 160 -6, 330 30, 500 12 S 840 -6, 1000 12" stroke="#DCEFBE" strokeWidth="2" fill="none" style={{ pathLength: len }} />
          </svg>
          <ol className="grid gap-12 md:grid-cols-3 md:gap-10">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} as="li" delay={i * 0.15} className="relative border-l border-[#DCEFBE]/25 pl-6 md:border-l-0 md:pl-0">
                <span data-testid={`process-step-${s.n}`} className="grid h-16 w-16 place-items-center rounded-full border border-[#DCEFBE]/40 bg-[#0D2F18] font-display text-2xl text-[#DCEFBE]">
                  {s.n}
                </span>
                <h3 className="mt-8 font-display text-3xl text-[#FBF9F4]">{s.title}</h3>
                <p className="mt-3 max-w-xs leading-relaxed text-[#FBF9F4]/80">{s.text}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
